<template>
  <!--Quote #1 START-->
  <!--Quote Wrapper START-->
  <div id="quote-0" class="row pt-4 mb-3 bg-white quote-wrap rounded shadow-sm">
    <div class="col px-0">
      <!--Result START-->
      <div class="row mx-0 mb-2 cm-success-row">
        <!--Carrier Column-->
        <div class="col-3 text-center">
          <div class="carrierLogo" :id="carrier.carrier_name">
            <img :src="carrier.logoPathSvg" :alt="carrier.carrier_name" width="100%" height="auto" />
          </div>
          <div class="quote-id-txt" v-if="carrier.customer_quoteid && (carrier.carrier_id !== 3)"><strong>Quote ID</strong>: {{ carrier.customer_quoteid }}</div>
          <div v-if="this.blurbs.CompanyInformation.content || this.blurbs.BeforeYouBuy.content || this.blurbs.ClaimsServices.content || this.blurbs.Ratings.content"
            class="carrierDetails smaller-font-content">
            <span class="txt-link ez-hover" @click="toggleElementDisplay('details_container_', carrier.carrier_id, false)">Carrier Details</span>
          </div>
        </div>
        <!--Monthly Payment Column-->
        <div class="col-3 text-center">
          <div class="quoteMonth">{{ carrier.monthly_premium | currency-filter }}</div>
          <div class="quoteTerm">/month</div>
          <div class="quoteTotMonth mt-2">{{ carrier.premium_amount | currency-filter }}</div>
          <div class="quoteTerm">Total for {{ carrier.policy_term }}</div>
        </div>

        <!--Total Payment Column-->
        <div class="col-3 text-center">
          <div class="quoteTot">{{ carrier.payinfull_amount | currency-filter }}</div>
          <div class="quoteTerm ">{{ carrier.policy_term }}</div>
          <div class="quoteSave mt-3" v-show="carrier.payinfull_discount > 0">Save {{ carrier.payinfull_discount | currency-filter }}</div>
        </div>

        <!--Button Column-->
        <div class="col-3 px-1 my-auto text-center">
          <!--The SELECT CARRIER BUTTON will sends the user to the carrier's website.-->
          <button id="select-carrier-btn" class="btn btn-primary mb-2" @click="openRc2Flow(carrier)" role="button" :disabled="enableSelect">Select Carrier</button>
          <!--The CARRIER DETAILS BUTTON targets the ID of the containing <tbody> with the carrier details container.-->
          <!-- <button class="btn btn-outline-primary detail-btn" @click="toggleElementDisplay('payment_details_', carrier.carrier_id, false)">Payment Details12</button> -->
          <div>
          <!-- <span class="fas fa-circle fa-stack-2x" ></span> -->
          <div class="d-inline-block  my-auto">
            <img width="14px" height="14x" src="../../../assets/info-circle-blue.svg" alt="info">
          </div>
             <b-button v-b-modal="carrier.carrier_name" class="Coverage-Payment-Details pt-2" variant="link">Coverage & Payment Details</b-button>
             </div>
        </div>
      </div>
       <!--nutan 2nd modal-->
    <div>
     <b-modal :id="carrier.carrier_name" class="coverageModal" size="lg" hide-footer :ref="carrier.carrier_name">
      <template  #modal-header>
         <div class="w-100 text-center">
         <img :src="carrier.logoPathSvg" :alt="carrier.carrier_name" class="carrierImageOnModal" />
         </div>
         <button type="button" class="close" data-dismiss="modal" aria-label="Close"   @click="closeModal(carrier.carrier_name)">
        <span aria-hidden="true">&times;</span>
       </button>
      </template>
     <div class="accordion" role="tablist">
      <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-1 variant="light">
         <span class="Coverage-Summary .-rem-600">
            Coverage Summary
         </span>
         <span data-v-87cda704="" class="toggle-icon">
         <i data-v-87cda704="" class="toggle-down fas fa-angle-down"></i>
         <i data-v-87cda704="" class="toggle-up fas fa-angle-up"></i>
        </span>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-1" visible accordion="paymentOptions" role="tabpanel">
        <b-card-body>
          <b-card-text><carrier-coverage-summary :carrier="carrier"></carrier-coverage-summary></b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.accordion-2 variant="light">
         <span class="Coverage-Summary .-rem-600">
            Payment Plan
         </span>
         <span data-v-87cda704="" class="toggle-icon">
           <i data-v-87cda704="" class="toggle-down fas fa-angle-down"></i>
           <i data-v-87cda704="" class="toggle-up fas fa-angle-up"></i>
         </span>
        </b-button>
      </b-card-header>
      <b-collapse id="accordion-2" accordion="paymentOptions" role="tabpanel">
        <b-card-body>
          <b-card-text>
             <div class="row no-gutters expandPanel show" :ref="'payment_details_plans'+carrier.carrier_id">
          <!--Payment Headers-->
          <div class="col-12">
            <div class="row no-gutters font-weight-bold">
              <div class="col-3 py-2 text-center border">
                Payment Plan
              </div>
              <div class="col-3 py-2 text-center border">
                Number of Payments
              </div>

              <div class="col-3 py-2 text-center border">
                Down Payments
              </div>

              <div class="col-3 py-2 text-center border">
                Installments
              </div>
            </div>
          </div>
          <div class="col-12" v-for="(plan, pKey) in carrier.payment_plans" :key="pKey+'_plan'">
            <div class="row no-gutters">

              <div class="col-3 py-2 text-center font-weight-bold border">
                {{ plan.plan_name }}
              </div>

              <div class="col-3 py-2 text-center border">
                {{ plan.numpayments }}
              </div>

              <div class="col-3 py-2 text-center border">
                {{ plan.downpayment | currency-filter }}
              </div>
              <div class="col-3 py-2 text-center border">
                {{ plan.installment_amount | currency-filter }}
              </div>
            </div>
          </div>
        </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <b-card no-body class="mb-1" v-if="this.blurbs.PaymentInformation.content">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.PaymentInformation variant="light">
          <span class="Coverage-Summary .-rem-600">
            Payment Information
         </span>
         <span data-v-87cda704="" class="toggle-icon">
           <i data-v-87cda704="" class="toggle-down fas fa-angle-down "></i>
           <i data-v-87cda704="" class="toggle-up fas fa-angle-up"></i>
         </span>
      </b-button>
      </b-card-header>
      <b-collapse id="PaymentInformation" accordion="paymentOptions" role="tabpanel">
        <b-card-body>
          <b-card-text>
            <div class="row mx-4 mt-2 no-gutters smaller-font-content expandPanel show" :ref="'payment_details_info'+carrier.carrier_id"
             v-if="this.blurbs.PaymentInformation.content" v-html="blurbs['PaymentInformation'].content">
            </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

      <b-card no-body class="mb-1" v-if="this.blurbs.CompanyInformation.content" >
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.companyInformation variant="light">
          <span class="Coverage-Summary .-rem-600">
           Company Information
         </span>
         <span data-v-87cda704="" class="toggle-icon">
           <i data-v-87cda704="" class="toggle-down fas fa-angle-down"></i>
           <i data-v-87cda704="" class="toggle-up fas  fa-angle-up"></i>
         </span>
      </b-button>
      </b-card-header>
      <b-collapse id="companyInformation" accordion="paymentOptions" role="tabpanel">
        <b-card-body>
          <b-card-text>
           <div class="row mx-4 mt-2 no-gutters smaller-font-content "  :ref="'details_company_info_'+carrier.carrier_id"
             v-html="blurbs['CompanyInformation'].content">
          </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

     <b-card no-body class="mb-1" v-if="this.blurbs.BeforeYouBuy.content" >
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.BeforeYouBuy variant="light">
          <span class="Coverage-Summary .-rem-600">
           Before You Buy
         </span>
         <span data-v-87cda704="" class="toggle-icon">
           <i data-v-87cda704="" class="toggle-down fas fa-angle-down"></i>
           <i data-v-87cda704="" class="toggle-up fas fa-angle-up"></i>
         </span>
      </b-button>
      </b-card-header>
      <b-collapse id="BeforeYouBuy" accordion="paymentOptions" role="tabpanel">
        <b-card-body>
          <b-card-text>
           <div class="row mx-4 mt-2 no-gutters smaller-font-content "  :ref="'details_company_info_'+carrier.carrier_id"
             v-html="blurbs['BeforeYouBuy'].content">
          </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
      <b-card no-body class="mb-1"  v-if="this.blurbs.ClaimsServices.content" >
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.ClaimsServices variant="light">
          <span class="Coverage-Summary .-rem-600">
           Claims & Services
         </span>
         <span data-v-87cda704="" class="toggle-icon">
           <i data-v-87cda704="" class="toggle-down fas  fa-angle-down"></i>
           <i data-v-87cda704="" class="toggle-up fas fa-angle-up "></i>
         </span>
      </b-button>
      </b-card-header>
      <b-collapse id="ClaimsServices" accordion="paymentOptions" role="tabpanel">
        <b-card-body>
          <b-card-text>
           <div class="row mx-4 mt-2 no-gutters smaller-font-content "  :ref="'details_company_info_'+carrier.carrier_id"
             v-html="blurbs['ClaimsServices'].content">
          </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1" v-if="this.blurbs.Ratings.content" >
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block v-b-toggle.Ratings variant="light">
          <span class="Coverage-Summary .-rem-600">
           Rating
         </span>
         <span data-v-87cda704="" class="toggle-icon">
           <i data-v-87cda704="" class="toggle-down fas fa-angle-down"></i>
           <i data-v-87cda704="" class="toggle-up fas fa-angle-up"></i>
         </span>
      </b-button>
      </b-card-header>
      <b-collapse id="Ratings" accordion="paymentOptions" role="tabpanel">
        <b-card-body>
          <b-card-text>
           <div class="row mx-4 mt-2 no-gutters smaller-font-content "  :ref="'details_company_info_'+carrier.carrier_id"
             v-html="blurbs['Ratings'].content">
          </div>
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>
  </div>
  </b-modal>
  </div>
      <!--nutan end 2nd modal-->
   </div>
  </div>
  <!--Quote Wrapper END-->
  <!--Quote #1 END-->
</template>

<script>
/* eslint-disable */
import Trap from 'vue-focus-lock';
import fetchData from '../../../services/fetchData';
import patchData from '../../../services/patchData';
import postData from '../../../services/postData';
import commonService from '../../../services/common';
import CarrierCoverageSummary from './CarrierCoverageSummary';

/**
 * CarrierDetailsSuccess.vue component represents a single carrier's successful row of info on the CarrierMatches page.
 *
 * CarrierDetailsSuccess.vue is a child component of CarrierMatches. In CarrierMatches, we v-for through our carrierSuccessArray[]
 * to display all successful carriers on the page. Each CarrierDetailsSuccess.vue is passed a Vue JS 'prop' for communication between
 * the Parent (CarrierMatches) component and the child (CarrierDetailsSuccess) component.
 *
 * We can see we name this Vue JS prop 'carrier' below:
 * Search for: props: ['carrier'],
 * So this 'carrier' property will hold All the necessary information to display this Carrier Success widget.
 *
 * Each Successful Carrier will have monthly and 'Pay in Full' payment columns/sections in their widgets. Each successful carrier will also
 * have buttons to reveal more company info as well as detailed payment plan information.
 *
 * When the 'Select Carrier' button is clicked, a NEW browser window will open with Carrier details. Not a new tab, but a NEW browser window
 * will open.
 */
export default {
  props: ['carrier'],
  components: {
    CarrierCoverageSummary,Trap
  },
  data() {
    return {
      blurbs: {},
      rc1NavButton:[],
      pageFieldsArray: [],
      pageData: {
        page_name: '',
        buttons: [],
        fields: [],
        blurbs: [],
        quote_summary: {},
      },
      selectCarrierLink: '',
       text: `
          Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry
          richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor
          brunch. Food truck quinoa nesciunt laborum eiusmod. Brunch 3 wolf moon
          tempor, sunt aliqua put a bird on it squid single-origin coffee nulla
          assumenda shoreditch et. Nihil anim keffiyeh helvetica, craft beer labore
          wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher
          vice lomo. Leggings occaecat craft beer farm-to-table, raw denim aesthetic
          synth nesciunt you probably haven't heard of them accusamus labore VHS.
     `
    };
  },
  computed: {
    enableSelect() {

      if(this.$store.state.buttonState.quoteSummaryData && this.$store.state.buttonState.quoteSummaryData.quote_status === 'Bound') {
        return true;
      } else {
        return !this.$parent.complete;
      }
    },
  },
  mounted(){
    console.log('in mounnnnnn',this.$store.getters.buttonsData);
    this.$store.dispatch('setNavButtonDataAction',this.$store.getters.buttonsData);
    Object.assign(this.rc1NavButton,this.$store.getters.buttonsData);
    sessionStorage.setItem('rc1NavButton',JSON.stringify(this.rc1NavButton));
  },
  methods: {
     OpenConfirmmodal() {
      this.$modal.show('confirm-save-modal');
    },
     closeModal(modalName) {
      this.$refs[modalName].hide();
    },
    close() {
        this.$emit('close');
        this.$bvModal.hide();
      },
    toggleElementDisplay(refName, carrierId, element) {
      //when 'Payment Details' is clicked, the payment plans should always be visible even if they toggled it off previously
      if (refName === 'payment_details_') {
        this.$refs['payment_details_plans' + carrierId].style.display = 'block';
        this.$refs['payment_details_plans_holder' + carrierId].classList.remove('inactive')
        this.$refs['payment_details_plans_holder' + carrierId].classList.add('active')
      }

      if (element) {
        this.updatePlusMinusSpanSymbol(element);
      }
      this.$refs[refName + carrierId].style.display == 'block' ? this.$refs[refName + carrierId].style.display = 'none' : this.$refs[refName + carrierId].style.display = 'block';
    },
    updatePlusMinusSpanSymbol(element) {
      if (element.classList.contains('active')) {
        element.classList.remove('active')
        element.classList.add('inactive')
      } else if (element.classList.contains('inactive')) {
        element.classList.remove('inactive')
        element.classList.add('active')
      }
    },
    /**
     * Open a totally new and independent browser window with the specified URL.
     */
    openRc2Flow(carData) {
      // todo: need to check if we can remove below const variable as its not in use 
      const navStatusObj= {
      page_name:'hodwelling',
      status:'ActiveFirstTime',
      };
      let session_id= this.$store.getters.getSessionID;
      let getUrl = `/pages/HORateCall2Details/${session_id}`;`/pages/HORateCall2Details/${session_id}`;
      let externalUrl = carData.external_url;
      sessionStorage.setItem('selectedCarrierHome', JSON.stringify(carData));
      sessionStorage.setItem('currentFlow', 'RC2');
      if (!externalUrl) {
      /* start for patch call for carrier*/
      let requestParams = {
        url: `/quotes/${session_id}/startbind`,
        data : {
            "carrierId": this.carrier.carrier_id
           },
          };
         /* start for patch call for carrier*/
        patchData.patchApi(requestParams).then((response) => {
          this.$store.dispatch('setCurrentNav',getUrl);
          // if carrier is branch then we dont need to display dwelling tab. Display it for all other carriers
          if (carData.carrier_id !== 171) {
            this.$store.dispatch('sethomeRc2Nav','hodwelling', getUrl);
            sessionStorage.setItem('sethomeRc2Nav', 'hodwelling');
            sessionStorage.setItem('setRc2NavFlowAction', true);
            this.$store.dispatch('setRc2NavFlowAction', true);
            this.$router.replace(commonService.getRouteName(getUrl));
          } else {
            const rateRequestParams = {
              url: `/pages/horatecall2details/${session_id}`,
            };
            fetchData.getPageData(rateRequestParams).then((response) => { 
              this.pageData = response.data;
              this.pageFieldsArray = this.pageData.fields;
              if (this.pageFieldsArray.some(field => field.section === 'Primary Mortgage' && field.visible)) {
                this.$store.dispatch('sethomeRc2Nav','homortgage');
                sessionStorage.setItem('sethomeRc2Nav', 'homortgage');
                sessionStorage.setItem('setRc2NavFlowAction', true);
                this.$store.dispatch('setRc2NavFlowAction', true);
                sessionStorage.setItem("mortgagehighlight",true);
                this.$router.replace('/home/mortgage');
              }else{
              this.$store.dispatch('sethomeRc2Nav','hocoverage');
              sessionStorage.setItem('sethomeRc2Nav', 'hocoverage');
              sessionStorage.setItem('setRc2NavFlowAction', true);
              this.$store.dispatch('setRc2NavFlowAction', true);
                sessionStorage.setItem("mortgagehighlight",false);
              this.$router.replace('/home/coverage');
            }
            });             
          }
          //this.$store.dispatch('setNavStatusAction', navStatusObj);
        }).catch((error) => {
        });
      }
      if (externalUrl) {
        let redUrl = '';
        for (let indexBtns = 0; indexBtns < carData.buttons.length; indexBtns += 1) {
          if (this.carrier.buttons[indexBtns].name === 'SelectCarrierButton') {
            redUrl = this.carrier.buttons[indexBtns].on_click;
          }
        }

        /**
        * Track Attempt Bind Start Event for external carriers(like, EZLynx, Non RC2 DI carriers, Lead Cloud) once user clicks on select carrier to continue RC2 flow
        */
        const requestParam = {
          url: redUrl,
          data : {
            session_id: this.$store.getters.getSessionID,
            page_name: this.$store.getters.getPageName,
          },
        };
        fetchData.fetchNavUrl(requestParam).then((response) => {
          if (response) {
            console.log('inside fetchNavUrl response not null usecase: ', response, options.isLoggingEnabled);
          }          
          if (response && response.data && response.data.Navigate) {
            // For Home flow, we should not have this code execution at all as we should not be using Navigation API
            console.log('inside fetchNavUrl success Navigate usecase: ', response.data.Navigate, options.isLoggingEnabled);
            this.$store.dispatch('setCurrentNav', response.data.Navigate);
            this.$router.replace(commonService.getRouteName(response.data.Navigate));
          }
        });

        //TODO::This is temporay fix for DI Carrier and for which we don't have RC2 flow
        //we might need to verify this code when we have multiple carriers with above scenario
        // if (carData.carrier_type === 'RATECARRIER' && !externalUrl && redUrl) {
        //   window.open(redUrl, "_blank");
        //   return;
        // }
        var strWindowFeatures = "location=yes,height=570,width=520,scrollbars=yes,status=yes";
        window.open(externalUrl, "_blank");
      }
    },
    checkBlurbs() {
      const blurbLocations = ['PaymentInformation', 'CompanyInformation', 'BeforeYouBuy', 'ClaimsServices', 'Ratings'];
      for (let i = 0; i < blurbLocations.length; i += 1) {
        if (!this.blurbs[blurbLocations[i]]) {
          this.blurbs[blurbLocations[i]] = {};
          this.blurbs[blurbLocations[i]].content = '';
        }
      }
    },
    setBlurbs() {
      for (let index = 0; index < this.carrier.blurbs.length; index += 1) {
        this.blurbs[this.carrier.blurbs[index].location] = {};
        this.blurbs[this.carrier.blurbs[index].location].content = this.carrier.blurbs[index].content;
      }
    },
    setBtns() {
      for (let indexBtns = 0; indexBtns < this.carrier.buttons.length; indexBtns += 1) {
        if (this.carrier.buttons[indexBtns].name === 'SelectCarrierButton') {
          this.selectCarrierLink = this.carrier.buttons[indexBtns].on_click;
        }
      }
    },
    init() {
      this.setBtns();
      this.setBlurbs();
      this.checkBlurbs();
    }
  },
  created() {
    this.init();
    // console.log('carrier ', this.carrier);
  },
  beforeDestroy() {
      this.$store.dispatch('setStartTime');
  },

  /*
  watch: {
    carrier: {
        handler: function(val, oldVal) {
            this.setBlurbs();
        },
        deep: true
    }
  },
  */
};
</script>

<style scoped lang="scss">
.coverageModal .card-header {
    padding: 0.5rem 1.25rem;
    background-color: white;
}
.coverageModal .card {
    border:0px !important;
}
.Coverage-Payment-Details {
  flex-grow: 0;
  font-family: Roboto;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left;
  color: $var-qs-dark-blue;
  text-transform: none !important;
  padding: 0px !important;
  font-size: 0.875rem;
  text-decoration: underline !important;
  cursor: pointer;
}
.Coverage-Payment-Details.btn-link:hover {
    color: $var-qs-dark-blue !important;
    text-decoration: underline;
}
.Coverage-Payment-Details.btn-link:focus {
box-shadow: 0 0 0 0 ;
}
.center {
  border: 5px solid;
  margin: auto;
  width: 50%;
  padding: 10px;
}
.modal-dialog .carrierLogo img{
    width: 100% !important;
    max-width: 132px;
    height: inherit !important;
    max-height: 39px;
}
.renters .bg-light {
  background-color: $var-renter-bg !important;
}
.home .bg-light {
  background-color: $var-home-bg !important;
}
.condo .bg-light {
  background-color: $var-color-condo-nav-bg !important;
}
.quote-id-txt {
  color: $var-color-faint-gray;
}
.plusminus.inactive::before {
  content: ' \002B';
}

.plusminus.active::before {
  content: ' \2013';
}

/***Quote***/
#results-table .quote-wrap{
  border-color: #003366 !important;
  border-width: 1rem !important;
}

/***Insurance Carrier Column***/
  #results-table .carrierLogo img, #knockout-wrap .carrierLogo img{
  width: 100% !important;
  max-width: 150px;
  height: inherit !important;
  max-height: 90px;
}

/***Avg. Monthly Column***/
#results-table .quoteTot, #results-table .quoteMonth{
  font-size: 1.25rem;
  font-weight: 700;
  color: $var-color-graydark;
}
/***Avg. Monthly Column***/

#results-table .quoteTerm{
  color: #999999;
  font-size: 0.875rem;
  text-transform: lowercase;
   color: $var-color-faint-gray;
}


#results-table .quoteTotMonth{
  color: #999999;
  font-size: 1rem;
  font-weight: 700;
  color: $var-color-faint-gray;
}


/***Total Column***/
#results-table .quoteSave{
  color: #00CC00;
  font-size: 1rem;
  font-weight: 700;
  color: $var-success-green;
}


/***Button Column***/
#results-table .btn{
  white-space: normal !important;
}

/**Carrier Details Hide/Show CSS**/
.detail-wrap{
display: none;
}

.txt-link {
  color: $var-text-link;
  font-size: 0.875rem;
  text-decoration: underline !important;
  cursor: pointer;
}

.pointer-class {
cursor: pointer;
}
.cm-success-row {
display: flex;
align-items: center;
}
</style>

<style>
.coverageModal .card-body{
font-size: .755rem !important;
color:#1a1a1a !important;
;
}
.carrierImageOnModal{
  width: 132px;
  height: 39px;
  object-fit: contain;
}
.not-collapsed > .when-closed {
  display: none;
}
.carrierInfo{
margin-top: 0.125rem;
}

.expandPanel ul li{
margin: 0.5rem 0;
}

#select-carrier-btn:disabled {
  background: #CCCCCC;
  border-color: #CCCCCC;
}

#select-carrier-btn:disabled:hover {
  color: #FFFFFF;
}
.noPaddingclass{
  padding-right:0px !important;
  padding-left:0px !important;
}
.buttons {
    display: flex;
    justify-content: space-between;
  }

  P.confirm-modal-content {
    font-weight: 600;
    color: #1A1A1A;
    font-size: 14px;
  }

  #confirm-submit-button,#confirm-submit-button:focus {
    background-color: #2E7B32 !important;;
    color: #fff !important;;
    border-color: #2E7B32 !important;;
  }

  #confirm-submit-button:hover {
    background-color: #fff !important;
    color: #2E7B32 !important;
  }

  #confirm-cancel-button {
    background-color: #fff;
    color: #999;
    border-color: #999;
  }

  #confirm-cancel-button:hover, #confirm-cancel-button:focus,#confirm-cancel-button:focus {
    background-color: #999 !important;
    color: #fff !important;
  }
.breakdown-modal-header {
  display: inline-block;
}

.uniform-icon-breakdown {
  font-size: .7rem;
  float: right;
}
div.breakdown-modal-top h3 {
  font-size: 1rem;
  font-weight: bold;
}

.bg-header-auto {
  background-color: #2D374C !important;
}
.Coverage-Summary {
  height: 18px;
  flex-grow: 1;
  font-family: Roboto;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: left !important;
  color:#333;
  text-transform: none !important;
}
/* .btn{
   text-align: left !important;
} */
.modal-header
{
  border-bottom: none !important;
  padding-bottom: 0px;
}
.modal-body
{
 
  padding-top: 0px;
}
.accordion:before {
  float:none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/interview/propertyInsurance/CarrierDetailsSuccess.vue?732379da